module.exports = __webpack_public_path__ + "img/IMG-8800.cff85088.jpg";